import { render, staticRenderFns } from "./ANZOPTION.vue?vue&type=template&id=4a52eb80"
import script from "./ANZOPTION.vue?vue&type=script&lang=js"
export * from "./ANZOPTION.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports